import { Button } from "../ui/Button"
import { SettingsContent } from "./SettingsCommon"
import { resetOnboarding } from "@/store/onboarding/onboarding-service"
import { routes } from "@/utils/routes"
import { queryClient } from "@/api/constants"
import { useTranslation } from "react-i18next"

export function Settings() {
	const navigateHome = routes.root.useNavigate()
	const { t } = useTranslation("components", { keyPrefix: "settingsPage" })
	const settingsLabel = t("settings")
	const settingsAriaLabel = t("ariaSettings")
	const resetOnboardingLabel = t("resetOnboarding")

	const handleResetOnboarding = async () => {
		await resetOnboarding()
		await queryClient.refetchQueries({ queryKey: ["projects"] })
		await navigateHome()
	}
	return (
		<div aria-label={settingsAriaLabel} className="flex size-full flex-col space-y-0">
			<div className="flex size-full flex-1 flex-col space-y-8 overflow-y-scroll bg-base-900 p-8">
				<div className="flex flex-row justify-between text-lg">
					<div className="text-xl font-bold">{settingsLabel}</div>
				</div>

				<SettingsContent layout="page" />

				<Button
					className="w-fit p-2"
					size="sm"
					trackingLabel="reset_onboarding"
					aria-label={resetOnboardingLabel}
					onClick={() => {
						void handleResetOnboarding()
					}}
				>
					{resetOnboardingLabel}
				</Button>
			</div>
		</div>
	)
}
